export default __webpack_public_path__ + "static/media/file2.49c62974.jpg";